<template>
  <div class="d-flex flex-column cert-incident-container mt-5" @click="()=>this.$router.push({path:path})">
    <div class="cert-img mx-auto">
      <img :src="imgPath"/>
    </div>
    <div class="cert-title mx-auto mt-2">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "CertIncidentContainer",
  props: {
    title: String,
    img: String,
    path: String,
  },
  computed: {
    imgPath() {
      return require(`../../../assets/img/incidents/${this.img}`);
    }
  },
}
</script>
